import { NavLink } from 'react-router-dom'

export function Navigation() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-dark-card border-t border-gray-700 safe-area-bottom">
      <div className="container mx-auto px-4">
        <div className="flex justify-around items-center h-16">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center min-w-[44px] min-h-[44px] px-3 py-2 rounded-lg transition-colors ${
                isActive
                  ? 'text-primary bg-primary/10'
                  : 'text-gray-400 hover:text-white'
              }`
            }
          >
            <span className="text-xs font-medium">Home</span>
          </NavLink>
          <NavLink
            to="/workouts"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center min-w-[44px] min-h-[44px] px-3 py-2 rounded-lg transition-colors ${
                isActive
                  ? 'text-primary bg-primary/10'
                  : 'text-gray-400 hover:text-white'
              }`
            }
          >
            <span className="text-xs font-medium">Workouts</span>
          </NavLink>
          <NavLink
            to="/nutrition"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center min-w-[44px] min-h-[44px] px-3 py-2 rounded-lg transition-colors ${
                isActive
                  ? 'text-primary bg-primary/10'
                  : 'text-gray-400 hover:text-white'
              }`
            }
          >
            <span className="text-xs font-medium">Nutrition</span>
          </NavLink>
          <NavLink
            to="/progress"
            className={({ isActive }) =>
              `flex flex-col items-center justify-center min-w-[44px] min-h-[44px] px-3 py-2 rounded-lg transition-colors ${
                isActive
                  ? 'text-primary bg-primary/10'
                  : 'text-gray-400 hover:text-white'
              }`
            }
          >
            <span className="text-xs font-medium">Progress</span>
          </NavLink>
        </div>
      </div>
    </nav>
  )
}
